import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

//refresh falha
let onUnauthorized = null;

export function setUnauthorizedHandler(handler) {
  onUnauthorized = typeof handler === 'function' ? handler : null;
}

let refreshPromise = null;

function isAuthPath(url = '') {
  const u = String(url);
  return (
    u.includes('auth/refresh') ||
    u.includes('auth/signin') ||
    u.includes('auth/signout') ||
    u.includes('auth/forgot_password') ||
    u.includes('auth/confirm_forgot_password') ||
    u.includes('auth/resolve-login')
  );
}

//renova idToken/accessToken via cookie refreshToken 
export async function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(
        `${API_BASE}auth/refresh`,
        null,
        {
          withCredentials: true,
          headers: { 'X-Skip-Auth-Retry': '1' },
        }
      )
      .then(() => true)
      .catch(() => false)
      .finally(() => {
        refreshPromise = null; 
      });
  }
  return refreshPromise;
}

function shouldSkipRetry(config = {}) {
  if (config._authRetried) return true; 
  if (config.headers?.['X-Skip-Auth-Retry'] === '1') return true;
  if (isAuthPath(config.url)) return true;
  return false;
}

async function handle401AndRetry(error, client) {
  const config = error?.config;
  if (!config || shouldSkipRetry(config)) {
    return Promise.reject(error);
  }

  const ok = await refreshSession();
  if (!ok) {
    //refresh falhou (cookie inválido/expirado)
    try {
      onUnauthorized?.();
    } catch (_) {
    }
    return Promise.reject(error);
  }

  config._authRetried = true;
  return client(config);
}

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 120_000,
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status !== 401) return Promise.reject(error);
    return handle401AndRetry(error, api);
  }
);

axios.defaults.withCredentials = true;
axios.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status !== 401) return Promise.reject(error);
    return handle401AndRetry(error, axios);
  }
);

export async function apiFetch(input, init = {}) {
  const opts = {
    credentials: 'include', 
    ...init,
    headers: { ...(init.headers || {}) },
  };

  const url = typeof input === 'string' ? input : input?.url;
  let res = await fetch(input, opts);

  if (res.status !== 401 || isAuthPath(url) || opts._authRetried) {
    return res;
  }

  const ok = await refreshSession();
  if (!ok) {
    try {
      onUnauthorized?.();
    } catch (_) {
    }
    return res; 
  }

  return fetch(input, { ...opts, _authRetried: true });
}

export default api;
